const state = {
  correlationId: null
}

const getters = {
  correlationId: state => state.correlationId
}

const actions = {
  setCorrelationId({ commit }, id) {
    commit('setCorrelationId', id)
  }
}

const mutations = {
  setCorrelationId(state, id) {
    state.correlationId = id
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
